import script from "./RubricQueryParameters.vue?vue&type=script&setup=true&lang=js"
export * from "./RubricQueryParameters.vue?vue&type=script&setup=true&lang=js"

import "./RubricQueryParameters.vue?vue&type=style&index=0&id=776199cc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-776199cc"]])

export default __exports__